import ApiClient from './ApiClient';

class AudiencesAPI extends ApiClient {
  constructor() {
    super('audiences', { accountScoped: true });
  }

  getContactsCount(audienceId) {
    return axios.get(`${this.url}/${audienceId}/contacts_count`);
  }
}

export default new AudiencesAPI();
